import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight, BadgeCheck, Globe2, Handshake } from "lucide-react";
import { CashNotice } from "@/components/site/CashNotice";

const PILLS = [
  [BadgeCheck, "ID-verified buyers only"],
  [Handshake, "In-person farm introductions"],
  [Globe2, "Buyers welcome worldwide"],
];

export const Hero = () => (
  <section className="relative min-h-[92vh] flex items-end overflow-hidden grain" data-testid="hero-section">
    <img src="/images/hero.jpg" alt="Greenhouse" className="absolute inset-0 h-full w-full object-cover" />
    <div className="absolute inset-0 bg-[#050F09]/75" />
    <div className="absolute -top-32 -right-32 h-[28rem] w-[28rem] rounded-full bg-purple-600/40 blur-3xl" />
    <div className="absolute bottom-0 -left-24 h-80 w-80 rounded-full bg-emerald-500/30 blur-3xl" />
    <div className="relative z-10 max-w-7xl mx-auto w-full px-5 sm:px-8 pt-32 pb-20 grid lg:grid-cols-12 gap-10">
      <motion.div className="lg:col-span-8 text-white" initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-4 py-1.5 eyebrow text-amber-300">
          Members only · By application
        </span>
        <h1 className="mt-6 text-4xl sm:text-5xl lg:text-7xl font-extrabold tracking-tight leading-[1.02]">
          Meet the farms.<br />
          <span className="inline-block pb-2 bg-gradient-to-r from-emerald-400 via-amber-300 to-orange-400 bg-clip-text text-transparent">Become the plug.</span>
        </h1>
        <p className="mt-6 text-base sm:text-lg text-white/80 max-w-xl leading-relaxed">
          A vetted network that personally introduces serious bulk flower buyers to trusted California cannabis farms.
          One-time membership. Real, in-person introductions. No middleman marketplace.
        </p>
        <div className="mt-9 flex flex-wrap gap-3">
          <Link to="/apply" data-testid="hero-apply-button" className="group inline-flex h-14 items-center gap-2 px-8 rounded-full bg-primary text-primary-foreground font-bold text-base btn-glow hover:-translate-y-1 transition-transform">
            Apply for Membership <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
          </Link>
          <a href="#tiers" data-testid="hero-view-tiers-button" className="inline-flex h-14 items-center px-8 rounded-full border border-white/30 bg-white/10 text-white font-semibold hover:bg-white/20 transition-colors">
            View Membership Tiers
          </a>
        </div>
      </motion.div>
      <motion.div className="lg:col-span-4 self-end space-y-3" initial={{ opacity: 0, x: 30 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.7, delay: 0.2 }}>
        {PILLS.map(([Icon, label]) => (
          <div key={label} className="flex items-center gap-3 rounded-2xl bg-white/10 backdrop-blur-xl border border-white/15 px-5 py-4 text-white">
            <Icon className="h-5 w-5 text-amber-300" />
            <span className="font-semibold">{label}</span>
          </div>
        ))}
        <CashNotice className="bg-[#0A170F]/80 text-white border-amber-400/50" testId="hero-cash-notice" />
      </motion.div>
    </div>
  </section>
);
